import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import { css } from "@emotion/react";
import React from "react";
import { FONTS, fontSize } from "../../../styles/fonts";
import { NewLabel, newStylesInline } from "../../../components/_shared-components/new/new-label";

const subHeadlineStyles = [
  FONTS.SwarovskiFutura300,
  fontSize.x2,
  css`
    color: var(--secondary-text-color);

    &:not(:last-of-type) {
      &:after {
        content: ", ";
      }
    }
  `,
];

export const PLPCardSubheadline: ReactTFC<{ subheadlines: Array<{ name: string; isNew: boolean }> }> = ({
  subheadlines,
}) => {
  if (subheadlines.length === 0) {
    return null;
  }

  return (
    <span className="u-mt-1">
      {subheadlines.map(({ name, isNew }) => {
        return (
          <span css={subHeadlineStyles} key={name}>
            <span css={newStylesInline}>
              {name}

              {isNew && (
                <NewLabel
                  inline={true}
                  css={css`
                    font-size: 0.5em;
                  `}
                />
              )}
            </span>
          </span>
        );
      })}
    </span>
  );
};
